<template>
  <div id="app">
    <navigation-bar />
    <router-view v-if="validTimestamp"/>
    <cookie-consent />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import NavigationBar from '@/components/NavigationBar.vue';
import CookieConsent from './components/CookieConsent.vue';

import { CookieHandler, CONSENT_TYPES } from '@/helpers/cookieHandler';

const route = useRoute();
const validTimestamp = ref(false);
const store = useStore();

watch(
  () => route.query,
  (queryNew) => {
    setTimeout(() => {
      validTimestamp.value = isYoungerThanOneHour(queryNew?.stamp);
      console.log(`The query param "stamp" is needed in a future release.`);

      console.log(`Currently it is set to ${queryNew?.stamp} and is ${validTimestamp.value ? "" : "not "}valid`);
      validTimestamp.value = true;

      const activeCategory = document.querySelector('.category-title.active');
      if (activeCategory) activeCategory.scrollIntoView({ behavior: 'smooth' });
    }, 350);
  },
  { deep: true, immediate: true }
);

const initializeGtm = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  }
  window.gtag('consent', 'default', {
    'analytics_storage': 'denied',
  });
};

const loadGtmServices = () => {
  const googleTagScript = document.createElement('script');
  googleTagScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-FCDVNMKFHF');
  googleTagScript.setAttribute('async', 'true');
  document.head.appendChild(googleTagScript);
  
  window.gtag('js', new Date()); 
  window.gtag('config', 'G-FCDVNMKFHF');
};

const isYoungerThanOneHour = (timestamp) => {
  const oneHour = 60 * 60 * 1000;
  return (new Date().getTime() - timestamp * 1000) < oneHour;
};

onMounted(() => {
  initializeGtm();

  const consent = CookieHandler.get(CONSENT_TYPES.YOUTUBE);
  const accepted = consent && consent['interacted'] && true === consent['accepted'];

  if (accepted) {
    loadGtmServices();
  }

  store.dispatch('setConsentAccepted', accepted);
});

watch(
  () => store.state.consentAccepted,
  (newVal) => {
    if (newVal) {
      loadGtmServices();
    }
  }
);
</script>

<style>
*, * *, h1, h2, h3, p, i, li, ul {
  margin: 0;
  padding: 0;

  font-family: Helvetica Neue, Arial, sans-serif;

  color: rgb(220, 220, 220);
}

img {
  object-fit: contain;
}

body {
  background-color: black;
  margin-bottom: 50px;
  width: 100vw;
  line-height: 1.3;
  height: 100%;
}
</style>